import { useEffect, useState } from "react";
import { Card, Badge, Spinner, Table, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function VectorDBCount() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchSchema = async () => {
      try {
        const res = await fetch(
          "https://admin.riameets.com/getUserVectorsSchema",
        );
        if (!res.ok) throw new Error("Failed to fetch schema");
        const json = await res.json();
        setData(json.result); // <-- IMPORTANT
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSchema();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 text-danger">
        {error}
      </div>
    );
  }

  return (
    <div className="container py-4">
      {/* Back Button */}
      <Button
        variant="secondary"
        className="mb-3"
        onClick={() => navigate("/")}
      >
        ← Back
      </Button>

      <h3 className="mb-4">User Vector Schema (Qdrant)</h3>

      {/* Status Cards */}
      <div className="row g-3 mb-4">
        <StatCard label="Collection Status" value={data.status} />
        <StatCard label="Optimizer" value={data.optimizer_status} />
        <StatCard label="Points" value={data.points_count} />
        <StatCard label="Indexed Vectors" value={data.indexed_vectors_count} />
      </div>

      {/* Vector Config */}
      <Card className="mb-4">
        <Card.Body>
          <h5>Vector Configuration</h5>
          <Badge bg="secondary" className="me-2">
            Size: {data.config.params.vectors.size}
          </Badge>
          <Badge bg="secondary">
            Distance: {data.config.params.vectors.distance}
          </Badge>
        </Card.Body>
      </Card>

      {/* Payload Schema */}
      <Card>
        <Card.Body>
          <h5 className="mb-3">Payload Schema</h5>
          <Table bordered responsive size="sm">
            <thead className="table-light">
              <tr>
                <th>Field</th>
                <th>Type</th>
                <th>Points</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(data.payload_schema).map(([key, val]) => (
                <tr key={key}>
                  <td>
                    <code>{key}</code>
                  </td>
                  <td>{val.data_type}</td>
                  <td>{val.points}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
}

function StatCard({ label, value }) {
  return (
    <div className="col-12 col-sm-6 col-lg-3">
      <Card>
        <Card.Body>
          <div className="text-muted small">{label}</div>
          <div className="fs-4 fw-semibold">{value}</div>
        </Card.Body>
      </Card>
    </div>
  );
}
